import React from 'react';
import { FormSection } from 'redux-form';
import styled from 'styled-components';

import IconStyled from 'components/MarkerSettings/IconStyled';
import IconCustom from 'components/MarkerSettings/IconCustom';
import { Radio } from 'components/Shared/Forms';
import { MARKER_TYPE } from 'components/MarkerSettings/IconOptions';
import Collapse from 'components/Shared/Collapse';
import { SETTINGS_INPUTS } from 'theme';

const StyledFormSection = styled(FormSection)`
    margin: -${SETTINGS_INPUTS.PADDING.Y} -${SETTINGS_INPUTS.PADDING.X};
    padding-left: ${SETTINGS_INPUTS.PADDING.X};
    padding-right: ${SETTINGS_INPUTS.PADDING.X};
`;

const StyledCollapse = styled(Collapse)`
    margin-right: -${SETTINGS_INPUTS.PADDING.X};
    margin-left: -${SETTINGS_INPUTS.PADDING.X};
`;

class IconSettings extends React.Component {
    isSelected = (type) => {
        return this.props.type === type;
    };

    render() {
        const { color, size, anchor, image } = this.props;
        return (
            <StyledFormSection name="icon">
                <Radio name="type" label="Default Google Maps Marker" value={MARKER_TYPE.DEFAULT} />
                <Radio name="type" label="Styled Marker" value={MARKER_TYPE.STYLED} />
                <StyledCollapse isOpened={this.isSelected(MARKER_TYPE.STYLED)}>
                    <IconStyled color={color} />
                </StyledCollapse>
                <Radio name="type" label="Custom Marker" value={MARKER_TYPE.CUSTOM} />
                <StyledCollapse isOpened={this.isSelected(MARKER_TYPE.CUSTOM)}>
                    <IconCustom image={image} size={size} anchor={anchor} />
                </StyledCollapse>
            </StyledFormSection>
        );
    }
}

export default IconSettings;
